import * as firebase from 'firebase';

const prodConfig = {
    apiKey: "AIzaSyC9OM19Xyc3jmdslS_LcAPea4Wl5feSAFI",
    authDomain: "fronttek-media.firebaseapp.com",
    databaseURL: "https://fronttek-media.firebaseio.com",
    projectId: "fronttek-media",
    storageBucket: "fronttek-media.appspot.com",
    messagingSenderId: "958042244111"
};

const devConfig = {
    apiKey: "AIzaSyC9OM19Xyc3jmdslS_LcAPea4Wl5feSAFI",
  authDomain: "fronttek-media.firebaseapp.com",
  databaseURL: "https://fronttek-media.firebaseio.com",
  projectId: "fronttek-media",
  storageBucket: "fronttek-media.appspot.com",
  messagingSenderId: "958042244111"
};

const configCap = {
    apiKey: "AIzaSyC9OM19Xyc3jmdslS_LcAPea4Wl5feSAFI",
    authDomain: "fronttek-media.firebaseapp.com",
    databaseURL: "https://fronttek-media.firebaseio.com",
    projectId: "fronttek-media",
    storageBucket: "fronttek-media.appspot.com",
    messagingSenderId: "958042244111"
};
/*
export const adverts = {
  apiKey: "AIzaSyA2SqJPOwJ8o2psPGiiKHBs-G6dE8yPQjk",
  authDomain: "sample-30824.firebaseapp.com",
  databaseURL: "https://sample-30824.firebaseio.com",
  projectId: "sample-30824",
  storageBucket: "sample-30824.appspot.com",
  messagingSenderId: "507533509225"
};
*/

export const adverts = {
  apiKey: "AIzaSyDGpA0qooKeiRAjQplSHKGz-nawULAEc2k",
  authDomain: "ntaandiview.firebaseapp.com",
  databaseURL: "https://ntaandiview.firebaseio.com",
  projectId: "ntaandiview",
  storageBucket: "ntaandiview.appspot.com",
  messagingSenderId: "1018749615697",
  appId: "1:1018749615697:web:a93fa30e2760c459ca8270",
  measurementId: "G-MX5YNB84R3"
};

firebase.initializeApp(adverts);
  // Get a reference to the storage service, which is used to create references in your storage bucket
 
 const storage = firebase.storage();
export const provider =new firebase.auth.GoogleAuthProvider();
export const auths=firebase.auth();
export default firebase;


const config = process.env.NODE_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth

}














